import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useEffect, useState, } from 'react';
import { useTheme } from '@mui/material';
import { Add, Remove } from '@mui/icons-material';
import { preventDefault, useCallbacks } from 'shared/hooks/utils';
import { useHeatingCircuit } from 'console/shared/components/panels/heating-circuits/heating-circuit/provider';
import { useHeatingCircuitControl } from 'console/shared/components/panels/heating-circuits/heating-circuit/provider/control';
import { useObserveControl } from 'console/shared/contexts/observe-control';
import { useDeviceConfig } from 'console/shared/contexts/device/config';
import { useLongPress } from 'shared/hooks/ui/long-press';
import * as S from './styles';
import { increaseTemp } from 'shared/components/dialogs/heating-circuit-widget/components/temperature-control/increase-temp';
import { partial } from 'utils';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { show_toast } from 'console/dialogs/toast';
import { selectDevice } from 'entities/device/lib';
export const TemperatureControlButtons = memo(function TemperatureControlButtons(props) {
    const { disabled, color, widget } = props;
    const { temp_step, device_id } = useDeviceConfig();
    const { min_temperature, max_temperature, thermometers: sensors, } = useHeatingCircuit();
    const { setTargetTemperature, turnOnEditingMode, target_fail, target_fail_message } = useHeatingCircuitControl();
    const { enableModalInteraction, disableModalInteraction } = useObserveControl();
    const onClickIncreaseTemp = useCallback((delta) => () => {
        setTargetTemperature(partial(increaseTemp, delta, sensors?.target.temperature, min_temperature, max_temperature));
    }, [
        setTargetTemperature,
        min_temperature,
        max_temperature,
        sensors?.target.temperature,
    ]);
    const [onLongPressClickStart, onLongPressClickEnd] = useLongPress();
    //Увеличиваю температуру при непрерывном нажатии на кнопку
    const onLongPressIncreaseTemp = useCallback((delta) => (event) => {
        preventDefault(event);
        turnOnEditingMode();
        disableModalInteraction?.();
        onLongPressClickStart(onClickIncreaseTemp(delta));
    }, [onClickIncreaseTemp]);
    const onLongPressEnd = useCallbacks([
        () => enableModalInteraction?.(),
        onLongPressClickEnd,
    ]);
    const onShowToast = useAction(show_toast);
    const action_fail = useAppSelector((state) => selectDevice(state, device_id))?.action_fail;
    const action_fail_message = useAppSelector((state) => selectDevice(state, device_id))?.action_fail_message;
    const [bg_color, setBgColor] = useState('inherit');
    const theme = useTheme();
    useEffect(() => {
        if (target_fail) {
            onShowToast(target_fail_message || 'Произошла ошибка');
            setBgColor(theme.palette.error.main);
            setTimeout(() => setBgColor('inherit'), 4000);
        }
        if (action_fail) {
            onShowToast(action_fail_message || 'Произошла ошибка');
            setBgColor(theme.palette.error.main);
            setTimeout(() => setBgColor('inherit'), 4000);
        }
    }, [target_fail, action_fail]);
    return (_jsxs(S.TemperatureControlButtonGroup, { group_color: color, widget: widget, disabled: disabled, fullWidth: true, variant: "text", "data-tooltip": widget ? 'change-temp-buttons' : undefined, children: [_jsx(S.TemperatureControlButton, { onClick: onClickIncreaseTemp(-temp_step), onPointerDown: onLongPressIncreaseTemp(-temp_step), onPointerUp: onLongPressEnd, onPointerLeave: onLongPressEnd, onContextMenu: preventDefault, style: { backgroundColor: bg_color }, children: _jsx(Remove, {}) }), _jsx(S.TemperatureControlButton, { onClick: onClickIncreaseTemp(temp_step), onPointerDown: onLongPressIncreaseTemp(temp_step), onPointerUp: onLongPressEnd, onPointerLeave: onLongPressEnd, onContextMenu: preventDefault, style: { backgroundColor: bg_color }, children: _jsx(Add, {}) })] }));
});
